import {RouteLocationNormalized} from "vue-router"

export default defineNuxtRouteMiddleware(async (to: RouteLocationNormalized, from: RouteLocationNormalized) => {
    useSearchStore().resetQueryString()
    if (import.meta.client && document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
    }
})